import React from 'react';

export default props => (
	<g>
		<rect className="line" x="4" y="15.2" width="24" height="1.6" />
	</g>
);
